export default "__VITE_ASSET__DSeccKdm__"